/**
 * 특차기사 (g5_member_relation status 4/5)
 * 레거시 _sky__m_menu_setting_003.php?md=1 + 003_1.php + saveinfo.spceialnumber 대체
 */
import Util from '../../Common/Util';
const ST_FEE   = 4; // 수수료 있음
const ST_NOFEE = 5; // 수수료 없음

// status 는 서버에서 intval 로 내려와 숫자다 — 문자열('5') 과 비교하면 항상 어긋난다
const isNoFee = (status) => parseInt(status, 10) === ST_NOFEE;

export default class RelationSpecial {
    constructor() {
        this.$table = null;
        this.editing = null; // {num, status} or null
    }

    initialize() {
        const self = this;
        this._initTable();

        $('#btn-special-add').on('click', () => self._openForm(null));
        const doSearch = () => self.$table.search($('#special-search').val()).draw();
        $('#special-search').on('keyup', (e) => { if (e.key === 'Enter') doSearch(); });
        $('#special-search-btn').on('click', doSearch);

        // 일지에서 직접 진입(직접 등록)
        const userid   = $('#direct-userid').val();
        const username = $('#direct-username').val();
        if (userid && userid.length > 5) {
            self._openForm(null, { mem_phone: userid, mem_name: username });
        }
    }

    _initTable() {
        const self = this;
        const isJbbuller = $('#is-jbbuller').val() === '1';

        const columns = [
            { data: 'mem_name',  title: '등록명', render: (d) => escapeHtml(d) },
            { data: 'mem_phone', title: '전화번호', render: (d) => escapeHtml(d) },
            {
                data: null, title: '수수료', orderable: false,
                render: (row) => isNoFee(row.status)
                    ? '<span style="color:red">없음</span>'
                    : '<span>있음</span>',
            },
            {
                data: null, title: '관리', orderable: false,
                // max-width:100% 필수 — 글자크기 확대 시 관리열이 좁아지는데(39→28px) 아이콘이
                // 30px 고정이면 열을 넘쳐 표 우측이 잘린다. 열 안에서 같이 줄어들게 한다.
                render: (row) => `<img src="/img/_top_app_icon_06.png" style="width:30px; max-width:100%; cursor:pointer" class="js-row-act" data-num="${row.num}" data-status="${row.status}" data-name="${escapeHtml(row.mem_name)}">`,
            },
        ];

        this.$table = new DataTable('#special-table', {
            // 글자크기(data-fs) 확대는 body 에 zoom 을 건다(base/_fontsize.scss). autoWidth 는
            // offsetWidth 로 표 폭을 재는데 그 값이 '확대된' px 라, 그걸 다시 인라인 width 로 쓰면
            // 렌더링에서 또 한 번 확대돼 표가 컨테이너(650px) 밖으로 밀려 우측이 잘린다.
            // (실측: 크게 650→780, 아주크게 650→910). 폭은 CSS 의 %/px 지정에 맡긴다.
            autoWidth: false,
            ajax: {
                url: '/m/ajax/relation/special/list',
                type: 'POST',
            },
            serverSide: true,
            processing: true,
            columns,
            ordering: false,
            lengthChange: false,
            pageLength: 30,
            dom: 'tip', // DataTables 기본 검색창/length 숨김 (커스텀 toolbar 사용)
            language: {
                emptyTable: '등록된 특차기사가 없습니다.',
                info:       '총 _TOTAL_명 중 _START_~_END_번째',
                infoEmpty:  '',
                infoFiltered: ' (전체 _MAX_명 중 검색)',
                processing: '불러오는 중…',
                paginate:   { first: '처음', last: '끝', next: '다음', previous: '이전' },
            },
        });

        $('#special-table tbody').on('click', '.js-row-act', function () {
            const $btn = $(this);
            self._openRowMenu({
                num: parseInt($btn.data('num')),
                status: parseInt($btn.data('status')),
                name: $btn.data('name'),
                feeMode: isJbbuller, // 장불 소속만 수수료 토글 노출
            });
        });
    }

    _openRowMenu(row) {
        const self = this;
        const opts = [];
        if (row.feeMode) {
            const nofee = isNoFee(row.status);
            opts.push({
                label: nofee ? '수수료 있음으로 변경' : '수수료 없음으로 변경',
                fn: () => self._updateFee(row.num, nofee ? 0 : 1),
            });
        }
        opts.push({ label: '삭제', fn: () => self._delete(row.num, row.name) });

        $j.Ui.Dialog.open({
            title:   row.name,
            choices: opts.map((o) => ({ label: o.label, onPick: o.fn })),
            cancel:  '닫기',
        });
    }

    _openForm(num, prefill = null) {
        const self = this;
        const isJbbuller = $('#is-jbbuller').val() === '1';
        const phone = prefill?.mem_phone || '';
        const name  = prefill?.mem_name  || '';

        const feeRow = isJbbuller ? `
            <div class="form-row">
                <label><input type="radio" name="nopeeset" value="1" style="vertical-align:middle"> 수수료 없음</label>
                &nbsp;&nbsp;
                <label><input type="radio" name="nopeeset" value="0" checked style="vertical-align:middle"> 수수료 있음</label>
            </div>` : '<input type="hidden" name="nopeeset" value="0">';

        const html = `
            <div class="form-row">
                <input type="tel" name="sp_number" id="sp_number" class="form-input" placeholder="등록할 전화번호" value="${escapeAttr(phone)}">
            </div>
            ${feeRow}
            <div class="bs-actions">
                <button type="button" class="btn btn-cancel js-cancel">취소</button>
                <button type="button" class="btn btn-ok js-save">확인</button>
            </div>`;
        // 제목은 모달 헤더가 든다 (구 본문 첫 줄의 제목 div 제거)
        this._modal = $j.Ui.Modal.open({ mode: 'center', variant: 'mobile', title: '특차기사 등록', html });

        $j.Common.Form.registerPhoneHandler('sp_number');

        this._modal.el.on('click', '.js-cancel', () => self._modal.close());
        this._modal.el.on('click', '.js-save', () => self._save());
    }

    _save() {
        const self = this;
        const $f = this._modal.el;
        const phone = $f.find('[name=sp_number]').val();
        const nopee = parseInt($f.find('[name=nopeeset]:checked').val() || 0);
        if (!phone) {
            Util.swalert('전화번호를 입력해 주세요');
            return;
        }
        // 기존 isExist 체크 재사용 (특차=수수료없음:5 / 수수료있음:4)
        $.get('/m/ajax/relation/isExist', { hp_num: phone, t: nopee === 1 ? ST_NOFEE : ST_FEE }, function (data) {
            if (!data.result) {
                Util.swalert(data.message);
                return;
            }
            const doSave = () => {
                $.post('/m/ajax/relation/special', { mem_phone: phone, nopeeset: nopee }, function (r) {
                    if (r.result) {
                        self._modal.close();
                        Util.swalert('등록되었습니다.', () => self.$table.ajax.reload(null, false));
                    } else {
                        Util.swalert(r.message || '오류가 발생했습니다.');
                    }
                });
            };
            if (data.message) Util.swalert(data.message, doSave, ['확인', '아니오']);
            else doSave();
        });
    }

    _updateFee(num, nopee) {
        const self = this;
        $.ajax({
            url: `/m/ajax/relation/special/${num}`,
            type: 'PUT',
            data: { nopeeset: nopee },
            success: (r) => {
                if (r.result) self.$table.ajax.reload(null, false);
            },
        });
    }

    _delete(num, name) {
        const self = this;
        Util.swalert([`${noTag(name)} 을(를) 특차에서 삭제할까요?`, 'question'], () => {
            $.ajax({
                url: `/m/ajax/relation/special/${num}`,
                type: 'DELETE',
                success: (r) => {
                    if (r.result) self.$table.ajax.reload(null, false);
                },
            });
        }, ['삭제', '아니오']);
    }
}

// 속성값(data-name="…")에도 들어가므로 따옴표까지 바꾸는 Util.escapeHtml 을 쓴다
const escapeHtml = (s) => Util.escapeHtml(s);
const escapeAttr = (s) => Util.escapeHtml(s);
// swalert 는 제목에 '<' 가 있으면 HTML 로 그린다 — 이름이 태그로 읽히지 않게 '<' 만 전각으로 바꾼다
const noTag = (s) => String(s ?? '').replace(/</g, '＜');
